import { render } from "./ProductSetCountryTemplate.vue?vue&type=template&id=96cfca22"
import script from "./ProductSetCountryTemplate.vue?vue&type=script&lang=js"
export * from "./ProductSetCountryTemplate.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__